import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Button, Form, Modal } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { setError, setSuccessMessage } from '../../modules/App/ErrorsActions';
import { applyView } from '../DashboardSelector/DashboardSelectorActions';
import * as BECaller from '../../util/apiCaller';
import throttle from '../../util/throttle';
import Confirm from '../Confirm/Confirm';

import Close from '../../assets/img/close.svg';
import deleteIcon from '../../assets/img/delete.svg';
import linkIcon from '../../assets/img/link.svg';
import checkCircleIcon from '../../assets/img/check-circle.svg';

import './modals.scss';
import { trackTeamDashboardViewURLCopy } from '../../util/mixpanel';

class DashboardViews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: props.visible,
      selected: '',
      q: '',
      loadingViews: false,
      applying: false,
      views: [],
      total: 0
    };

    this.search = throttle(this._search, 500, this);
  }

  _search = q => {
    BECaller.api(`/dashboards/${this.props.dashboard._id}/views?q=${q}`, 'get').then(
      res => {
        this.setState({
          views: res.data,
          total: res.total
        });
      },
      err => {
        this.props.setError(err);
      }
    );
  };

  deleteView = id => {
    if (!id) {
      this.props.setError('Please select a view');
      return false;
    }

    const views = _.filter(this.state.views, v => {
      return v._id !== id;
    });
    this.setState({ views });

    BECaller.api(`/dashboards/${this.props.dashboard._id}/views/${id}`, 'delete')
      .then(() => {
        this.search(this.state.q);
      })
      .catch(err => {
        this.props.setError(err);
      });
  };

  handleCopied = () => {
    this.props.setSuccess('URL copied');

    trackTeamDashboardViewURLCopy();
  };

  handleSearch = e => {
    this.setState({ q: e.target.value }, () => {
      this.search(this.state.q);
    });
  };

  onButtonClick = () => {
    if (!this.state.isOpened) {
      this.setState({
        q: '',
        selected: '',
        isOpened: true,
        loadingViews: true,
        applying: false
      });

      BECaller.api(`/dashboards/${this.props.dashboard._id}/views`, 'get').then(
        res => {
          this.setState({
            loadingViews: false,
            views: res.data,
            total: res.total
          });
        },
        err => {
          this.props.setError(err);
        }
      );
    }
  };

  onClose = event => {
    if (event) {
      event.stopPropagation();
    }
    this.setState({
      isOpened: false
    });
  };

  onConfirm = () => {
    if (!this.state.selected) {
      this.props.setError('Please select a view');
      return false;
    }

    this.setState({
      applying: true
    });

    this.props.applyView(this.props.dashboard._id, this.state.selected).then(
      () => {
        this.setState({
          isOpened: false,
          applying: false
        });
      },
      () => {
        this.setState({
          applying: false
        });
      }
    );
  };

  render() {
    var modal = (
      <Modal show={this.state.isOpened} onHide={this.onClose} className='modal-dashboard-view'>
        <Modal.Header>
          <Modal.Title>Apply dashboard view</Modal.Title>
          <Button variant="close" onClick={this.onClose}>
            <img src={Close} alt="close" />
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div className='dashboard-view'>
            <div className='dashboard-view-form-wrap'>
              <Form.Group controlId="q">
                <div className='search-wrap'>
                  <Form.Control 
                    type="text" 
                    name="q"  
                    value={this.state.q} 
                    onChange={this.handleSearch} 
                    placeholder='Search Dashboard View' />
                </div>
              </Form.Group>
              {!!this.state.views.length && (
                <div className="dashboard-view-list">
                  {this.state.views.map((v, i) => {
                    return (
                      <div
                        key={i}
                        className={`dashboard-view-item ${(v._id === this.state.selected) ? 'selected' : ''}`}
                        onClick={() => this.setState({ selected: v._id })}
                      >
                        <span className='dashboard-view-name'>{v.name}</span>
                        <CopyToClipboard
                          text={`${window.location.protocol}//${window.location.host}/dashboard/${this.props.dashboard._id}?view=${v._id}`}
                          onCopy={this.handleCopied}
                        >
                          <Button variant="light-secondary" size="sm" className='btn-icon'>
                            <img src={linkIcon} alt="link" />
                          </Button>
                        </CopyToClipboard>
                        <Confirm
                          onConfirm={() => this.deleteView(v._id)}
                          body={
                            <p>
                              Are you sure you want to remove <br />
                              <strong>{v.name}</strong> view from your dashboard?
                            </p>
                          }
                          confirmText="Remove"
                          icon={deleteIcon}
                          title="Remove Dashboard View"
                        >
                          <Button variant="danger" size="sm" className='btn-icon'>
                            <img src={deleteIcon} alt="delete" />
                          </Button>
                        </Confirm>
                      </div>
                    );
                  })}
                </div>
              )}

              {!!this.state.loadingViews && <div className='no-results'>Loading...</div>}

              {!this.state.loadingViews && !this.state.views.length && (
                <div className='no-results'>No results found</div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary"
            disabled={!this.state.selected || this.state.applying}
            onClick={this.onConfirm}
          >
            <img src={checkCircleIcon} alt='' />
            {this.state.applying ? 'Applying...' : 'Apply'}
          </Button>
          <Button variant="secondary" onClick={this.onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );

    var content;
    if (this.props.children) {
      var btn = React.Children.only(this.props.children);
      content = React.cloneElement(
        btn,
        {
          onClick: this.onButtonClick,
          style: this.props.style
        },
        btn.props.children,
        modal
      );
    } else {
      content = (
        <Button onClick={this.onButtonClick} style={this.props.style}>
          {this.props.buttonText}
          {modal}
        </Button>
      );
    }

    return content;
  }
}

const mapDispatchToProps = dispatch => {
  return {
    applyView: (dashboardId, viewId) => dispatch(applyView(dashboardId, viewId)),
    setError: err => dispatch(setError(err)),
    setSuccess: msg => dispatch(setSuccessMessage(msg, { toastId: 'url_success' }))
  };
};

const mapStateToProps = state => {
  return {
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardViews);
